export function isChartPanelTableMetadata(metadata) {
  return metadata.settings !== undefined;
}
export function isChartPanelFigureMetadata(metadata) {
  return metadata.figure !== undefined;
}
export function isGLChartPanelState(panelState) {
  if (panelState == null) return false;
  var _ref = panelState,
    settings = _ref.settings,
    tableSettings = _ref.tableSettings;
  return typeof settings === 'object' && typeof tableSettings === 'object';
}
export function isChartPanelDehydratedProps(props) {
  return props != null && isGLChartPanelState(props.panelState);
}
//# sourceMappingURL=ChartPanelUtils.js.map